import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import FeaturesGrid from "./components/FeaturesGrid";
import LocationsSection from "./components/LocationsSection";
import SpecialistCareSection from "./components/SpecialistCareSection";
import HeritageTableSection from "./components/HeritageTableSection";
import IntelligentCareSection from "./components/IntelligentCareSection";
import WellnessSection from "./components/WellnessSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navigation />
      <main>
        <HeroSection />
        <PhilosophySection />
        <FeaturesGrid />
        <LocationsSection />
        <SpecialistCareSection />
        <HeritageTableSection />
        <IntelligentCareSection />
        <WellnessSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
